module.exports = __webpack_public_path__ + "img/top.d736918f.jpg";